import { mixpanel } from '@/helpers/analytics';

export const useAdvisorSearchRecommendedKeywords = (isSp: boolean) => {
  const path = (keyword: string) => {
    return {
      query: {
        keyword,
      },
    };
  };

  const onClick = (keyword: string) => {
    mixpanel.track('Click Search Recommended Keyword', {
      keyword,
      is_sp: isSp,
    });
  };

  return {
    path,
    onClick,
  };
};

type RecommendedCategories = {
  categoryName: string;
  items: {
    label: string;
    searchQuery: string;
  }[];
}[];

export const recommendedCategories: RecommendedCategories = [
  {
    categoryName: '広報',
    items: [
      {
        label: '立ち上げ',
        searchQuery: '(広報 OR PR) AND (立ち上げ OR 一人 OR １人)',
      },
      {
        label: '広報戦略',
        searchQuery: '広報戦略 OR PR戦略',
      },
      {
        label: 'SNS活用',
        searchQuery: '(広報 OR PR) AND SNS AND アカウント',
      },
      {
        label: '効果測定',
        searchQuery: '(広報 OR PR) AND 効果測定',
      },
      {
        label: '危機管理広報',
        searchQuery: '危機管理広報',
      },
    ],
  },
  {
    categoryName: 'マーケティング',
    items: [
      {
        label: '組織の立ち上げ',
        searchQuery:
          'マーケティング組織  OR マーケ組織 OR (マーケティング AND (一人 OR １人))',
      },
      {
        label: 'マーケティング戦略',
        searchQuery: 'マーケティング戦略 OR マーケ戦略',
      },
      {
        label: '代理店選定・活用',
        searchQuery:
          'マーケ AND (代理店選定 OR 代理店の選定 OR 代理店活用 OR 代理店の活用)',
      },
      {
        label: 'データ分析',
        searchQuery: 'マーケ AND データ分析 AND (DMP OR CDP)',
      },
      {
        label: 'BtoBマーケティング',
        searchQuery:
          'BtoBマーケ OR (BtoB向けマーケ) OR (BtoBサービス AND マーケ)',
      },
    ],
  },
  {
    categoryName: '営業・事業開発',
    items: [
      {
        label: '営業戦略',
        searchQuery: '営業戦略 AND (営業マネジメント OR 組織マネジメント)',
      },
      {
        label: '販売代理店・パートナー営業',
        searchQuery:
          '(営業 OR セールス OR sales) AND (販売パートナー OR 代理店パートナー OR 販売代理店 OR パートナー営業 OR 代理店営業 OR 代理店マネジメント)',
      },
      {
        label: 'アライアンス戦略',
        searchQuery:
          '(営業 OR セールス OR sales OR 事業開発 OR Bizdev) AND (アライアンス戦略 OR パートナーシップ)',
      },
      {
        label: 'エンタープライズセールス',
        searchQuery:
          'エンタープライズセールス OR エンプラ OR 大手向け営業 OR 大手企業向け営業 OR 大手向け法人営業 OR 大手法人営業',
      },
      {
        label: 'アップセル・クロスセル',
        searchQuery: 'アップセル OR クロスセル',
      },
    ],
  },
  {
    categoryName: '生産・研究開発',
    items: [
      {
        label: 'PoC・実証実験',
        searchQuery: '(PoC OR 実証実験) AND 研究',
      },
      {
        label: '研究開発マネジメント',
        searchQuery: '研究開発マネジメント',
      },
      {
        label: 'DX・デジタル化',
        searchQuery:
          '("研究開発" OR "商品開発" OR "技術開発" OR "開発部門" OR "生産") AND ("DX" OR "デジタル化")',
      },
      {
        label: '研究開発テーマの企画・推進',
        searchQuery: '研究テーマ OR 開発テーマ',
      },
      {
        label: 'ハードウェア品質',
        searchQuery: 'ハードウェア AND 品質',
      },
    ],
  },
  {
    categoryName: '人事',
    items: [
      {
        label: '人事制度・報酬制度',
        searchQuery: '人事制度 AND 構築',
      },
      {
        label: 'リファラル採用',
        searchQuery: 'リファラル採用',
      },
      {
        label: 'HRBP',
        searchQuery: 'HRBP OR HRビジネスパートナー',
      },
      {
        label: '組織体制',
        searchQuery: '(人事 OR HR) AND 組織体制',
      },
      {
        label: 'ストックオプション・株式報酬',
        searchQuery: 'ストックオプション OR 株式報酬 OR SO',
      },
    ],
  },
  {
    categoryName: '財務・経理・管理',
    items: [
      {
        label: '予算策定・予実管理',
        searchQuery: '予算策定 AND 予実管理',
      },
      {
        label: 'バックオフィスの業務フロー',
        searchQuery: 'バックオフィス AND 業務フロー',
      },
      {
        label: '内部統制・コンプライアンス',
        searchQuery: '(内部統制 OR コンプライアンス) AND 体制',
      },
      {
        label: 'システム導入',
        searchQuery: '(会計システム OR 経理システム) AND 導入',
      },
      {
        label: '自動化・DX',
        searchQuery: '(経理 OR 財務) AND (自動化 OR DX)',
      },
    ],
  },
];
